//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OrganizacionComponent from '@/components/OrganizacionComponent.vue';
import { PATTERNS_VALIDATION, ALL_TABLES_OPTION } from '@/js/constants';
export default {
  name: 'SearchInTable',
  components: {
    OrganizacionComponent: OrganizacionComponent
  },
  props: {
    placeholder: {
      type: String,
      required: false,
      default: 'Search by tableasd criteria...'
    },
    withConditions: {
      type: Boolean,
      required: false,
      default: true
    },
    defaultDomain: {
      type: String,
      required: false,
      default: null
    },
    showDomains: {
      type: Boolean,
      required: false,
      default: true
    },
    showAllFilter: {
      type: Boolean,
      required: false,
      default: true
    },
    showSynapse: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      data: {
        name: null,
        projectid: null,
        column: null,
        tags: {
          operator: {
            value: null,
            symbol: ':'
          },
          env: {
            value: null,
            symbol: '='
          }
        }
      },
      list_env: [{
        value: null,
        text: this.traductor('my_tasks.all')
      }, {
        value: 'dev',
        text: this.traductor('my_tasks.development')
      }, {
        value: 'test',
        text: this.traductor('my_tasks.test')
      }],
      q: '',
      SEARCH_PATTERN: PATTERNS_VALIDATION.MAIN_SEARCH,
      choose_domain: null,
      showOptions: false,
      list_source: [{
        value: 'bigquery',
        text: "Bigquery"
      }, {
        value: 'synapse',
        text: "Azure Synapse"
      }],
      source: 'bigquery'
    };
  },
  computed: {
    text: function text() {
      return this.$i18n.t('frases.search_table');
    },
    processd_list_domains: function processd_list_domains() {
      var list_domains = [];
      if (this.showDomains) {
        list_domains = window.userInfo ? Object.values(window.userInfo.listOrgs) : [];
        list_domains.unshift(window.userInfo.domain);
        if (this.showAllFilter) {
          list_domains.push(ALL_TABLES_OPTION);
        }
      } else {
        list_domains.unshift(window.userInfo.domain);
      }
      return list_domains;
    },
    conditionsOption: function conditionsOption() {
      return this.showOptions ? 'remove' : 'add';
    }
  },
  watch: {
    'choose_domain': function choose_domain(newVal, oldVal) {
      if (!this.showOptions && oldVal != null) {
        this.submitConditions(null);
      }
    }
  },
  created: function created() {
    if (this.defaultDomain == null) {
      this.choose_domain = window.userInfo ? window.userInfo.domain : null;
    } else {
      this.choose_domain = this.defaultDomain;
    }
  },
  methods: {
    handlerShow: function handlerShow(value) {
      this.showOptions = value;
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onReset: function onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.data.name = null;
      this.data.projectid = null;
      this.data.column = null;
      this.data.tags.operator.value = null;
      this.data.tags.env.value = null;
      this.data.clear = true;
      this.data.conditions = null;
      var data = this.prepareData(this.data);
      this.$emit('submit', data.query, data.domain, data.allDomains, undefined, this.source);
    },
    submit: function submit(evt) {
      if (this.choose_domain != null) {
        evt.preventDefault();
        var data = this.prepareData();
        this.$emit('submit', data.query, data.domain, data.allDomains, this.data.clear ? null : data.conditions, this.source);
      }
    },
    submitConditions: function submitConditions() {
      var data = this.prepareData(this.data);
      this.$emit('submit', data.query, data.domain, data.allDomains, data.conditions, this.source);
    },
    prepareData: function prepareData() {
      var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var allDomains = null;
      var domain = null;
      var query = this.data.name;
      if (this.choose_domain === ALL_TABLES_OPTION) {
        allDomains = true;
        domain = null;
      } else {
        allDomains = false;
        domain = this.choose_domain;
      }
      return {
        query: query,
        allDomains: allDomains,
        domain: domain,
        conditions: conditions
      };
    }
  }
};